// Built-in Pine Script Lite example scripts

export interface PineExample {
  id: string
  title: string
  description: string
  code: string
}

export const PINE_EXAMPLES: PineExample[] = [
  {
    id: 'sma_crossover',
    title: 'SMA Crossover',
    description: 'Two simple moving averages — 20 and 50 period',
    code: `//@version=5
indicator("SMA Crossover", overlay=true)
fast = input.int(20, title="Fast Length")
slow = input.int(50, title="Slow Length")
fastSma = ta.sma(close, fast)
slowSma = ta.sma(close, slow)
plot(fastSma, title="Fast SMA", color="#2962ff")
plot(slowSma, title="Slow SMA", color="#ff6d00")`,
  },
  {
    id: 'ema_ribbon',
    title: 'EMA Ribbon',
    description: '3 EMA lines — 9, 21 and 55 period',
    code: `//@version=5
indicator("EMA Ribbon", overlay=true)
e1 = ta.ema(close, 9)
e2 = ta.ema(close, 21)
e3 = ta.ema(close, 55)
plot(e1, title="EMA 9",  color="#2962ff")
plot(e2, title="EMA 21", color="#26a69a")
plot(e3, title="EMA 55", color="#ef5350")`,
  },
  {
    id: 'rsi',
    title: 'RSI',
    description: 'Relative Strength Index with overbought/oversold levels',
    code: `//@version=5
indicator("RSI", overlay=false)
length = input.int(14, title="Length")
rsiVal = ta.rsi(close, length)
plot(rsiVal, title="RSI", color="#2962ff")
hline(70)
hline(30)`,
  },
  {
    id: 'macd',
    title: 'MACD',
    description: 'Moving Average Convergence Divergence',
    code: `//@version=5
indicator("MACD", overlay=false)
fastLen = input.int(12, title="Fast")
slowLen = input.int(26, title="Slow")
signalLen = input.int(9, title="Signal")
[macdLine, signalLine, hist] = ta.macd(close, fastLen, slowLen, signalLen)
plot(macdLine,   title="MACD",   color="#2962ff")
plot(signalLine, title="Signal", color="#ff6d00")
plotHistogram(hist, title="Histogram", color="#26a69a")`,
  },
  {
    id: 'bollinger_bands',
    title: 'Bollinger Bands',
    description: 'Standard deviation bands around a moving average',
    code: `//@version=5
indicator("Bollinger Bands", overlay=true)
length = input.int(20, title="Length")
mult   = input.int(2,  title="Multiplier")
[middle, upper, lower] = ta.bb(close, length, mult)
plot(upper,  title="Upper",  color="#ef5350")
plot(middle, title="Middle", color="#2962ff")
plot(lower,  title="Lower",  color="#26a69a")`,
  },
  {
    id: 'atr',
    title: 'ATR',
    description: 'Average True Range — volatility indicator',
    code: `//@version=5
indicator("ATR", overlay=false)
length = input.int(14, title="Length")
atrVal = ta.atr(length)
plot(atrVal, title="ATR", color="#ff9800")`,
  },
  {
    id: 'supertrend',
    title: 'Supertrend',
    description: 'Trend-following indicator with dynamic support/resistance',
    code: `//@version=5
indicator("Supertrend", overlay=true)
factor = input.int(3,  title="ATR Factor")
period = input.int(10, title="ATR Period")
[st, direction] = ta.supertrend(factor, period)
plot(st, title="Supertrend", color="#2962ff")`,
  },
  {
    id: 'vwap',
    title: 'VWAP',
    description: 'Volume Weighted Average Price',
    code: `//@version=5
indicator("VWAP", overlay=true)
vwapVal = ta.vwma(close, 20)
plot(vwapVal, title="VWAP", color="#9c27b0")`,
  },
  {
    id: 'stochastic',
    title: 'Stochastic',
    description: 'Stochastic oscillator — %K line',
    code: `//@version=5
indicator("Stochastic", overlay=false)
kPeriod = input.int(14, title="K Period")
dPeriod = input.int(3,  title="D Period")
kLine = ta.stoch(close, high, low, kPeriod)
dLine = ta.sma(kLine, dPeriod)
plot(kLine, title="%K", color="#2962ff")
plot(dLine, title="%D", color="#ff6d00")
hline(80)
hline(20)`,
  },
  {
    id: 'obv',
    title: 'OBV',
    description: 'On-Balance Volume — cumulative volume pressure',
    code: `//@version=5
indicator("OBV", overlay=false)
obvVal = ta.obv(close, volume)
obvEma = ta.ema(obvVal, 20)
plot(obvVal, title="OBV",     color="#2962ff")
plot(obvEma, title="OBV EMA", color="#ff9800")`,
  },
]

export function getExampleById(id: string): PineExample | undefined {
  return PINE_EXAMPLES.find((e) => e.id === id)
}
